<template>
  <div class="form-wrapper">
    <v-form v-model="isVerified">
      <editor for-reference @done="e => (text = e)" />
    </v-form>
    <v-spacer />
    <div class="actions layout mt-4 align-center">
      <div>
        <input v-model="extend" type="checkbox" :value="extend" />
        <span class="muted ml-2">Add more</span>
      </div>
      <v-spacer />
      <core-button
        secondary
        class="mr-3"
        not-rounded
        flat
        label="Cancel"
        @click.stop="$router.push({ query: { dialog: null, form: null } })"
      />
      <core-button
        :is-loading="isLoading"
        :disabled="!text"
        not-rounded
        flat
        label="Create Reference"
        @click.stop="createReference"
      />
    </div>
  </div>
</template>

<script>
import CoreButtonVue from '../../../buttons/CoreButton.vue';
import { CREATE_FLOW, CREATE_REFERENCE, GET_ALL_REFERENCES } from '../../../../../config/constants';
import EditorComponentVue from '../../../../editor/EditorComponent.vue';
export default {
  name: 'CreateReferenceDialog',
  components: {
    coreButton: CoreButtonVue,
    editor: EditorComponentVue
  },
  data() {
    return {
      text: null,
      isVerified: false,
      isLoading: false,
      extend: false
    };
  },
  methods: {
    createReference() {
      if (this.isVerified) {
        if (!this.text) return;
        this.isLoading = true;

        this.$store
          .dispatch(CREATE_REFERENCE, { text: this.text })
          .then(async slide => {
            await this.$store.dispatch('alerts/success', 'Created Reference');
            await this.$store.dispatch(GET_ALL_REFERENCES);
            if (!this.extend) this.$router.push({ query: { dialog: null, form: null } });
            this.text = null;
          })
          .catch(err => {})
          .finally(() => (this.isLoading = false));
      }
    }
  }
};
</script>

<style scoped>
.form-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
